const booleanTransformator = {
  toModelAttribute(value) {
    if (value === "") {
      return null;
    }

    return value;
  },

  toFormAttribute(value) {
    if ([true, false].includes(value)) {
      return value;
    }

    return "";
  },
};

export default booleanTransformator;
